export default __webpack_public_path__ + "static/media/ic_send.aff53929.svg";